import notify from '@ananasbear/notify';

export default async response => {
  switch (response.code) {
    case 200:
    case 201:
    case 204:
      return true
    case 400: {
      const errors = await response.data.json()

      if (Array.isArray(errors)) {
        notify.warning(`notify.requestErrors.${ errors[0].replace(/ /g, '_').replace('.', '').replace('`', '').replace(',', '') }`)
      } else {
        if (errors.eu_description) {
          notify.warning(errors.eu_description)
          return
        }
        for (let error in errors) {
          if (Array.isArray(errors[error])) {
            notify.warning(`notify.requestErrors.${ errors[error][0].replace(/ /g, '_').replace('.', '').replace('`', '').replace(',', '') }`)
          } else {
            notify.warning(`notify.requestErrors.${ errors[error].replace(/ /g, '_').replace('.', '').replace('`', '').replace(',', '') }`)
          }
        }
      }
      return false
    }
    case 404: {
      const errors = await response.data.json()
      
      if (Array.isArray(errors)) {
        notify.warning(`notify.requestErrors.${ errors[0].replace(/ /g, '_').replace('.', '') }`)
      } else {
        for (let error in errors) {
          if (Array.isArray(errors[error])) {
            notify.warning(`notify.requestErrors.${ errors[error][0].replace(/ /g, '_').replace('.', '') }`)
          } else {
            notify.warning(`notify.requestErrors.${ errors[error].replace(/ /g, '_').replace('.', '') }`)
          }
        }
      }
      return false
    }
    case 422: {
      const details = await response.data.json()
      for (let detail in details) {
        notify.warning(`notify.requestErrors.${ details[detail].replace(/[^a-zA-Z]+/g, '_') }`)
      }
    }
    default:
      return false
  }
}
